    import React, { useState, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import Header from '../components/Header';

const gradYears = ['2026', '2027', '2028', '2029', '2030', '2031', '2032'];

export default function Register() {
  const [form, setForm] = useState({
    firstName: localStorage.getItem('studentFirstName') || '',
    lastName: localStorage.getItem('studentLastName') || '',
    schoolEmail: localStorage.getItem('studentSchoolEmail') || '',
    personalEmail: localStorage.getItem('studentPersonalEmail') || '',
    gradYear: localStorage.getItem('studentGradYear') || '',
    isParent: localStorage.getItem('studentIsParent') === 'true' || false,
    subject: '',
    isMentorship: localStorage.getItem('studentIsMentorship') === 'true' || false
  });
  const [errors, setErrors] = useState({});
  const [submitted, setSubmitted] = useState(false);
  const [tutorBookingLink, setTutorBookingLink] = useState('');
  
  function validate() {
    const newErrors = {};
    if (!form.firstName.trim()) newErrors.firstName = 'First name is required.';
    if (!form.lastName.trim()) newErrors.lastName = 'Last name is required.';
    if (!form.schoolEmail.trim()) newErrors.schoolEmail = 'School email is required.';
    else if (!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(form.schoolEmail)) newErrors.schoolEmail = 'Invalid email.';
    if (!form.personalEmail.trim()) newErrors.personalEmail = 'Personal Gmail is required.';
    else if (!/^[^@\s]+@gmail\.com$/.test(form.personalEmail)) newErrors.personalEmail = 'Must be a Gmail address.';
    if (!form.gradYear) newErrors.gradYear = 'Graduation year is required.';
    // Subject is required for tutoring but optional for mentorship
    if (tutorId && !form.isMentorship && !form.subject.trim()) {
      newErrors.subject = 'Subject is required for tutoring requests.';
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  }

  const [searchParams] = useSearchParams();
  const tutorId = searchParams.get('tutor');
  const mentorParam = searchParams.get('mentor');
  const schoolParam = searchParams.get('school'); // 'ja' = Jane Addams, 'wr' = Will Rogers
  const [isFromMentorDirectory, setIsFromMentorDirectory] = useState(false);
  const [isFromJaneAddams, setIsFromJaneAddams] = useState(false);
  const [isFromWillRogers, setIsFromWillRogers] = useState(false);
  const [isFromSMC, setIsFromSMC] = useState(false);

  // Track page view with Google Analytics
  useEffect(() => {
    if (typeof window !== 'undefined' && window.gtag) {
      window.gtag('config', 'G-CC8DD4BS2W', {
        page_path: '/register',
        page_title: 'Student Registration'
      });
    }
  }, []);

  // Check if coming from Mentor Directory and set isMentorship accordingly
  useEffect(() => {
    const fromMentor = mentorParam === 'true' || window.location.pathname.includes('MBMentor');
    setIsFromMentorDirectory(fromMentor);
    if (fromMentor) {
      setForm(f => ({ ...f, isMentorship: true }));
      localStorage.setItem('studentIsMentorship', 'true');
    }
  }, [mentorParam]);

  // Check if coming from Jane Addams or Will Rogers via URL param (reliable; referrer is often blocked)
  useEffect(() => {
    setIsFromJaneAddams(schoolParam === 'ja');
    setIsFromWillRogers(schoolParam === 'wr');
    setIsFromSMC(schoolParam === 'smc');
  }, [schoolParam]);

useEffect(() => {
  if (tutorId) {
    const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || '';
    fetch(`${API_BASE_URL}/api/tutors`)
      .then(res => res.json())
      .then(tutors => {
        console.log('🔍 DEBUG - All tutors fetched:', tutors);
        console.log('🔍 DEBUG - Looking for tutorId:', tutorId);
        const tutor = tutors.find(t => t.id == tutorId);
        console.log('🔍 DEBUG - Found tutor:', tutor);
        console.log('🔍 DEBUG - Tutor bookingLink:', tutor?.bookingLink);
        if (tutor && tutor.bookingLink) {
          console.log('✅ Found tutor with bookingLink:', tutor.bookingLink);
          console.log('✅ Tutor details:', { id: tutor.id, name: tutor.firstName + ' ' + tutor.lastName });
          setTutorBookingLink(tutor.bookingLink);
        } else {
          console.log('❌ No tutor found or no bookingLink');
          console.log('❌ Tutor data:', { tutor, hasBookingLink: tutor?.bookingLink });
        }
      })
      .catch(err => {
        console.error('Error fetching tutor data:', err);
      });
  }
}, [tutorId]);

  async function handleSubmit(e) {
    e.preventDefault();
    if (!validate()) return;
    try {
      const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || '';
      let url = `${API_BASE_URL}/api/students`;
      let payload = { ...form };
      if (tutorId) {
        url = `${API_BASE_URL}/api/book`;
        payload.tutorId = tutorId;
        payload.isFromJaneAddams = isFromJaneAddams || isFromWillRogers;
        payload.isFromSMC = isFromSMC;
      }
      const res = await fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
      });
      if (res.ok) {
        // Save to localStorage for autofill next time
        localStorage.setItem('studentFirstName', form.firstName);
        localStorage.setItem('studentLastName', form.lastName);
        localStorage.setItem('studentSchoolEmail', form.schoolEmail);
        localStorage.setItem('studentPersonalEmail', form.personalEmail);
        localStorage.setItem('studentGradYear', form.gradYear);
	localStorage.setItem('studentIsParent', form.isParent);
	localStorage.setItem('studentIsMentorship', form.isMentorship);
        setSubmitted(true);
      } else {
        const errText = await res.text();
        alert('Error registering student. Please try again. ' + errText);
      }
    } catch (err) {
      alert('Could not connect to the server.');
    }
  }

  if (submitted) {
    console.log('✅ Submitted block is rendering');
    const getIframeUrl = () => {
      console.log('🔍 DEBUG - getIframeUrl called, tutorBookingLink state:', tutorBookingLink);
      if (!tutorBookingLink) {
        console.log('⚠️ WARNING - tutorBookingLink is empty!');
      }
      return tutorBookingLink;
    };

    return (
      <div style={{padding: '2rem'}}>
        <Header />
        <h2>Thank you for registering for the Honor Society Tutors program.</h2>
        <p>We will share this information with your tutor and they will contact you.</p>
        <div style={{margin: '2rem 0'}}>
          <iframe
            src={getIframeUrl()}
            width="100%"
            height="600"
            frameBorder="0"
            style={{
              border: '1px solid #ddd',
              borderRadius: '8px',
              boxShadow: '0 2px 8px rgba(0,0,0,0.1)'
            }}
            title="Amelia Booking Calendar"
          />
        </div>
        {/* Note section commented out - can be restored later
        <div style={{
          marginTop: '1rem',
          padding: '1rem',
          backgroundColor: '#f8f9fa',
          borderRadius: '4px',
          fontSize: '14px',
          color: '#666'
        }}>
          <p><strong>Note:</strong> Your registration information has been saved and will be shared with your tutor.</p>
        </div>
        */}
      </div>
    );
  }

  return (
    <div>
      <Header />
      <div style={{
        maxWidth: '600px',
        margin: '0 auto',
        padding: '2rem',
        fontFamily: 'Arial, sans-serif'
      }}>
        <h1 style={{
          textAlign: 'center',
          color: '#333',
          marginBottom: '1rem',
          fontSize: '2.5rem',
          fontWeight: 'bold'
        }}>
          Student Registration
        </h1>
        
        <p style={{
          textAlign: 'center',
          color: '#666',
          marginBottom: '2rem',
          fontSize: '1.1rem',
          lineHeight: '1.5',
          backgroundColor: '#f8f9fa',
          padding: '1rem',
          borderRadius: '8px',
          border: '1px solid #e9ecef'
        }}>
          {isFromSMC ? (
            'Thank you for signing up for the SMC PTK Tutors program. Please enter your information below and your tutor will contact you to set up your tutoring or mentorship session.'
          ) : (
            <>
              Thank you for signing up for the Honor Society Tutors program. Please enter your information below and your tutor will contact you to set up your tutoring or mentorship session.
              <br />
              <br />
              Parents: If you are completing this form for your child, check "Parent," enter your name and personal email, and enter your child's high school graduation date and school email address.
            </>
          )}
        </p>
        
        {/* Registration Form */}
        <form onSubmit={handleSubmit} noValidate style={{
          backgroundColor: 'white',
          padding: '2rem',
          borderRadius: '12px',
          boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
          border: '1px solid #e9ecef'
        }}>
          <div style={{ marginBottom: '1.5rem' }}>
            <label style={{
              display: 'block',
              marginBottom: '0.5rem',
              fontWeight: 'bold',
              color: '#333'
            }}>
              First Name:
            </label>
            <input 
              type="text" 
              name="firstName" 
              value={form.firstName} 
              onChange={e => setForm(f => ({...f, firstName: e.target.value}))} 
              required 
              style={{
                width: '100%',
                padding: '0.75rem',
                border: '2px solid #ddd',
                borderRadius: '6px',
                fontSize: '1rem',
                boxSizing: 'border-box',
                transition: 'border-color 0.3s ease'
              }}
              onFocus={e => e.target.style.borderColor = '#007bff'}
              onBlur={e => e.target.style.borderColor = '#ddd'}
            />
            {errors.firstName && <div style={{color:'#dc3545', fontSize:'0.875rem', marginTop:'0.25rem'}}>{errors.firstName}</div>}
          </div>

          <div style={{ marginBottom: '1.5rem' }}>
            <label style={{
              display: 'block',
              marginBottom: '0.5rem',
              fontWeight: 'bold',
              color: '#333'
            }}>
              Last Name:
            </label>
            <input 
              type="text" 
              name="lastName" 
              value={form.lastName} 
              onChange={e => setForm(f => ({...f, lastName: e.target.value}))} 
              required 
              style={{
                width: '100%',
                padding: '0.75rem',
                border: '2px solid #ddd',
                borderRadius: '6px',
                fontSize: '1rem',
                boxSizing: 'border-box',
                transition: 'border-color 0.3s ease'
              }}
              onFocus={e => e.target.style.borderColor = '#007bff'}
              onBlur={e => e.target.style.borderColor = '#ddd'}
            />
            {errors.lastName && <div style={{color:'#dc3545', fontSize:'0.875rem', marginTop:'0.25rem'}}>{errors.lastName}</div>}
          </div>

          <div style={{ marginBottom: '1.5rem' }}>
            <label style={{
              display: 'block',
              marginBottom: '0.5rem',
              fontWeight: 'bold',
              color: '#333'
            }}>
              Personal Gmail:
            </label>
            <input 
              type="email" 
              name="personalEmail" 
              value={form.personalEmail} 
              onChange={e => setForm(f => ({...f, personalEmail: e.target.value}))} 
              required 
              style={{
                width: '100%',
                padding: '0.75rem',
                border: '2px solid #ddd',
                borderRadius: '6px',
                fontSize: '1rem',
                boxSizing: 'border-box',
                transition: 'border-color 0.3s ease'
              }}
              onFocus={e => e.target.style.borderColor = '#007bff'}
              onBlur={e => e.target.style.borderColor = '#ddd'}
            />
            {errors.personalEmail && <div style={{color:'#dc3545', fontSize:'0.875rem', marginTop:'0.25rem'}}>{errors.personalEmail}</div>}
          </div>

          <div style={{ marginBottom: '1.5rem' }}>
            <label style={{
              display: 'block',
              marginBottom: '0.5rem',
              fontWeight: 'bold',
              color: '#333'
            }}>
              School Email:
            </label>
            <input 
              type="email" 
              name="schoolEmail" 
              value={form.schoolEmail} 
              onChange={e => setForm(f => ({...f, schoolEmail: e.target.value}))} 
              required 
              style={{
                width: '100%',
                padding: '0.75rem',
                border: '2px solid #ddd',
                borderRadius: '6px',
                fontSize: '1rem',
                boxSizing: 'border-box',
                transition: 'border-color 0.3s ease'
              }}
              onFocus={e => e.target.style.borderColor = '#007bff'}
              onBlur={e => e.target.style.borderColor = '#ddd'}
            />
            {errors.schoolEmail && <div style={{color:'#dc3545', fontSize:'0.875rem', marginTop:'0.25rem'}}>{errors.schoolEmail}</div>}
          </div>

          <div style={{ marginBottom: '2rem' }}>
            <label style={{
              display: 'block',
              marginBottom: '0.5rem',
              fontWeight: 'bold',
              color: '#333'
            }}>
              High School Graduation Year:
            </label>
            <select 
              name="gradYear" 
              value={form.gradYear} 
              onChange={e => setForm(f => ({...f, gradYear: e.target.value}))} 
              required 
              style={{
                width: '100%',
                padding: '0.75rem',
                border: '2px solid #ddd',
                borderRadius: '6px',
                fontSize: '1rem',
                boxSizing: 'border-box',
                backgroundColor: 'white',
                transition: 'border-color 0.3s ease'
              }}
              onFocus={e => e.target.style.borderColor = '#007bff'}
              onBlur={e => e.target.style.borderColor = '#ddd'}
            >
              <option value="">Select Year</option>
              {gradYears.map(yr => <option key={yr} value={yr}>{yr}</option>)}
            </select>
            {errors.gradYear && <div style={{color:'#dc3545', fontSize:'0.875rem', marginTop:'0.25rem'}}>{errors.gradYear}</div>}
          </div>

{tutorId && (
  <div style={{ marginBottom: '2rem' }}>
    <label style={{
      display: 'block',
      marginBottom: '0.5rem',
      fontWeight: 'bold',
      color: '#333'
    }}>
      {form.isMentorship 
        ? 'Mentorship Topic (Optional):'
        : 'Subject for Tutoring (Enter "Mentor" if you want a Mentorship session):'}
    </label>
    <input 
      type="text"
      name="subject" 
      value={form.subject} 
      onChange={e => setForm(f => ({...f, subject: e.target.value}))} 
      placeholder={form.isMentorship 
        ? "Enter topic (e.g., College Prep, Course Selection, Extracurriculars)"
        : "Enter subject (e.g., AP Calculus, Middle School Algebra, AP Euro)"}
      required={!form.isMentorship}
      style={{
        width: '100%',
        padding: '0.75rem',
        border: '2px solid #ddd',
        borderRadius: '6px',
        fontSize: '1rem',
        boxSizing: 'border-box',
        transition: 'border-color 0.3s ease'
      }}
      onFocus={e => e.target.style.borderColor = '#007bff'}
      onBlur={e => e.target.style.borderColor = '#ddd'}
    />
    {errors.subject && <div style={{color:'#dc3545', fontSize:'0.875rem', marginTop:'0.25rem'}}>{errors.subject}</div>}
  </div>
)}

          {tutorId && (
            <div style={{ marginBottom: '2rem' }}>
              <label style={{
                display: 'flex',
                alignItems: 'center',
                cursor: isFromMentorDirectory ? 'not-allowed' : 'pointer',
                color: '#333',
                opacity: isFromMentorDirectory ? 0.7 : 1
              }}>
                <input 
                  type="checkbox" 
                  name="isMentorship" 
                  checked={form.isMentorship}
                  disabled={isFromMentorDirectory}
                  onChange={e => {
                    if (!isFromMentorDirectory) {
                      setForm(f => ({...f, isMentorship: e.target.checked}));
                    } else {
                      alert('This is a mentorship request from the Mentor Directory and cannot be changed.');
                    }
                  }}
                  style={{
                    width: '20px',
                    height: '20px',
                    marginRight: '10px',
                    cursor: isFromMentorDirectory ? 'not-allowed' : 'pointer'
                  }}
                />
                <span style={{ fontWeight: 'bold' }}>
                  This is a Mentorship request
                </span>
              </label>
              {isFromMentorDirectory && (
                <div style={{ fontSize: '0.875rem', color: '#666', marginTop: '0.25rem', fontStyle: 'italic' }}>
                  This checkbox is locked because you came from the Mentor Directory.
                </div>
              )}
            </div>
          )}

           <div style={{ marginBottom: '2rem' }}>
  		<label style={{
    		display: 'flex',
    		alignItems: 'center',
    		cursor: 'pointer',
    		color: '#333'
          }}>
    	    <input 
      		type="checkbox" 
      		name="isParent" 
      		checked={form.isParent}
      		onChange={e => setForm(f => ({...f, isParent: e.target.checked}))}
      		style={{
        	 width: '20px',
        	 height: '20px',
        	 marginRight: '10px',
        	 cursor: 'pointer'
      		}}
    	/>
    	<span style={{ fontWeight: 'bold' }}>
      	 I am a parent filling out this form
    	</span>
       </label>
      </div>

          <div style={{ textAlign: 'center' }}>
            <button 
              type="submit" 
              style={{
                backgroundColor: '#28a745',
                color: 'white',
                padding: '1rem 2rem',
                border: 'none',
                borderRadius: '8px',
                fontSize: '1.1rem',
                fontWeight: 'bold',
                cursor: 'pointer',
                transition: 'all 0.3s ease',
                boxShadow: '0 2px 4px rgba(40, 167, 69, 0.3)'
              }}
              onMouseEnter={e => {
                e.target.style.backgroundColor = '#218838';
                e.target.style.transform = 'translateY(-2px)';
                e.target.style.boxShadow = '0 4px 8px rgba(40, 167, 69, 0.4)';
              }}
              onMouseLeave={e => {
                e.target.style.backgroundColor = '#28a745';
                e.target.style.transform = 'translateY(0)';
                e.target.style.boxShadow = '0 2px 4px rgba(40, 167, 69, 0.3)';
              }}
            >
              Register
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

